import classNames from 'classnames';

import { DATETIME_FORMATS, DateUtils } from '@/common/utils';

interface EmployeeIdpNextReviewDateCellProps {
  nextReviewDate: Date | number | string | null | undefined;
}

export const EmployeeIdpNextReviewDateCell = ({ nextReviewDate }: EmployeeIdpNextReviewDateCellProps) => {
  const diff = DateUtils.getDifferenceString(nextReviewDate);

  return (
    <div>
      <div>{DateUtils.formatDate(nextReviewDate, DATETIME_FORMATS.MMMddyyyy)}</div>
      <div className={classNames('text-2xs', { 'text-failure': !diff.isFuture, 'text-gray-7': diff.isFuture })}>
        {diff.text}
        {diff.isFuture ? '' : ' ago'}
      </div>
    </div>
  );
};
